import { render, staticRenderFns } from "./UploadSuccessfulReport.vue?vue&type=template&id=3bc5fd70&"
import script from "./UploadSuccessfulReport.vue?vue&type=script&lang=js&"
export * from "./UploadSuccessfulReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports